module.exports = "//static.hsappstatic.net/growth-data-modal/static-1.2618/images/google-contacts.svg"